import { LocationData } from '../types/LocationData';

export const buildLocationLabel = (location: LocationData) => {
  const { label, iata, icao, unlocode } = location;
  const details = [iata, icao, unlocode].filter((code) => !!code);
  const detailsString = details.join(', ');

  if (detailsString) return `${label} (${detailsString})`;
  return label;
};

export const prepareLocaitonOptions = (locations: LocationData[]) => {
  return locations.map(location => ({ ...location, label: buildLocationLabel(location) }));
};